<template>
  <FiltersWatcher :filters="filters" @change="$emit('change', $event)">
    <SectionGroup gap="larger">
      <FormSection title="Ваш запрос">
        <DropdownSelect
          full-width
          placeholder="Любой"
          v-model="filters.rid"
          :options="options.requestGroups"
        />
      </FormSection>
      <FormSection title="Ваша квалификация">
        <DropdownSelect
          full-width
          placeholder="Любая"
          v-model="filters.qid"
          :options="options.qualifications"
        />
      </FormSection>
      <FormSection title="Какие навыки вы хотите развить">
        <SkillsPicker
          v-model="filters.skills"
          :skills.sync="dynamicOptions.skills"
          :disabled="filters.skills && filters.skills.length >= 10"
        />
      </FormSection>
      <FormSection title="Специализация эксперта">
        <SpecsPicker
          :groups="options.groups"
          :selected-categories="filters.sid"
          :s-options="options.specializations"
          v-model="filters.sid"
        />
      </FormSection>

      <FormSection title="Стоимость часа эксперта">
        <SectionGroup gap="medium">
          <InputRangeGroup
            dropdown
            :from.sync="filters.rateFrom"
            :to.sync="filters.rateTo"
            :measure.sync="filters.currency"
            :measure-options="options.currencies"
            :disabled="filters.freeOnly"
          />
          <BasicCheckbox
            v-model="filters.freeOnly"
            @update:modelValue="removePrice"
            :value="true"
          >
            Бесплатно
          </BasicCheckbox>
          <BasicCheckbox
            v-model="filters.freeIntro"
            :disabled="filters.freeOnly"
            :value="true"
          >
            Первая встреча бесплатно
          </BasicCheckbox>
        </SectionGroup>
      </FormSection>

      <FormSection title="Компания эксперта">
        <SectionGroup gap="medium">
          <CompanyPicker
            v-model="filters.companies"
            multiple
            :companies.sync="dynamicOptions.companies"
          />
          <BasicCheckbox
            v-model="filters.excludeCompany"
            :value="1"
            :disabled="!filters.companies || filters.companies.length === 0"
          >
            Исключить из поиска
          </BasicCheckbox>
          <BasicCheckbox
            v-model="filters.isCurrentCompany"
            :value="1"
            :disabled="!filters.companies || filters.companies.length === 0"
          >
            Текущее место работы
          </BasicCheckbox>
        </SectionGroup>
      </FormSection>

      <slot name="controls" />
    </SectionGroup>
  </FiltersWatcher>
</template>

<script>
import FiltersWatcher from 'src/components/filters/FiltersWatcher/FiltersWatcher.vue';
import BasicCheckbox from 'src/components/form/BasicCheckbox/BasicCheckbox.vue';
import DropdownSelect from 'src/components/form/DropdownSelect/DropdownSelect.vue';
import FormSection from 'src/components/form/FormSection/FormSection.vue';
import InputRangeGroup from 'src/components/form/InputRangeGroup/InputRangeGroup.vue';
import CompanyPicker from 'src/components/pickers/CompanyPicker/CompanyPicker.vue';
import SkillsPicker from 'src/components/pickers/SkillsPicker/SkillsPicker.vue';
import SpecsPicker from 'src/components/pickers/SpecsPicker/SpecsPicker.vue';
import SectionGroup from 'src/components/sections/SectionGroup/SectionGroup.vue';

export default {
  name: 'ExpertFilters',
  components: {
    CompanyPicker,
    InputRangeGroup,
    DropdownSelect,
    FiltersWatcher,
    BasicCheckbox,
    SkillsPicker,
    SpecsPicker,
    FormSection,
    SectionGroup,
  },

  props: {
    filters: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    dynamicOptions: {
      type: Object,
      required: true,
    },
  },

  methods: {
    removePrice(isFree) {
      if (isFree) {
        this.filters.rateFrom = null;
        this.filters.rateTo = null;
        this.filters.freeIntro = false;
      }
    },
  },
};
</script>
